import React from 'react'
import '../pages/pages.css'
import '../components/components.css'
import { NavLink } from 'react-router'
import menu from '../assets/menu.JPG'
import dancing from '../assets/dancing.JPG'

const Creative = () => {
  return (
    <div  id='creative'>
        <div id='header-title'>
            <NavLink to="/">josh popp</NavLink>
        </div>
        <div>
            <img alt='image of 3 people dancing' className='photo' src={dancing}></img>
            <img alt='image of a menu and currywurst' className='photo' src={menu}></img>
            <img alt='image of 3 people dancing' className='photo' src={dancing}></img>
            <img alt='image of a menu and currywurst' className='photo' src={menu}></img>
        </div>
    </div>
  )
}

export default Creative